import { Country } from "./country.model";

export class CustomerCountry {
    countryCode?: string;
    countryId?: number;
    countryName?: string;
}

export class Customer {
    customerName?: string;
    customerId?: number;
    customerCode?: string;
    customerCountry?: CustomerCountry;
    unitSystem?: string;
    isDummy?: boolean;
}

export class Uom {
    uomCode?: string;
    isDefault?: boolean;
    uomType?: string;
}

export class UomsType {
    metricUoms?: Uom[];
    imperialUoms?: Uom[];
}

export class ApplicableNorm {
    addenda?: string;
    applicableNormId?: number;
    designation?: string;
    edition?: string;
    normCode?: string;
    testCategory?: string;
}

export class EnquirySms {
    description?: string;
    name?: string;
    smsId?: number;
    marketingRoute?: string;
}

export class SalesOffice {
    officeCode?: string;
    officeId?: number;
    officeName?: string;
}

export class SalesOfficePerson {
    officeId?: number;
    isDefault?: boolean;
}

export class SalesPerson {
    userId?: number;
    username?: string;
    isDefault?: boolean;
    salesOffices?: SalesOfficePerson[];
}

export class MarketFamily {
    description?: string;
    isDefaultForStock?: boolean;
    isDefaultForProject?: boolean;
    marketFamilyId?: number;
    name?: string;
}

export class OrderReason {
    value?: string;
    isDefault?: boolean;
}

export class OfferValidity {
    id?: Number;
    en?: String;
    it?: String;
    de?: String;
    fr?: String;
    daysNumber?: Number;
    isDefault?: boolean;
    isCustom?: boolean
}

export class OfferScheme {
    offerSchemeCode?: string;
    offerSchemeDescription?: string;
    isDefault?: boolean;
}

export class BonusScheme {
    bonusSchemeCode?: string;
    bonusSchemeDescription?: string;
    isDefault?: boolean;
}

export class HeaderParametersValues {
    countries?: Country[];
    currencies?: string[];
    customers?: Customer[];
    testCategories?: string[];
    odUoms?: UomsType[];
    wtUoms?: UomsType[];
    idUoms?: UomsType[];
    totalWeightUoms?: UomsType;
    lengthUoms?: UomsType;
    sms?: EnquirySms[];
    salesPersons?: SalesPerson[];
    salesOffices?: SalesOffice[];
    marketFamily?: MarketFamily[];
    mstOfferStatus?: string[];
    orderReasons?: OrderReason[];
    offerValidities?: OfferValidity[];
    offerSchemes?: OfferScheme[];
    bonusSchemes?: BonusScheme[];
}
